<div *ngIf="!pageLoaded" class="appLoadingContainer">
  <i class="fa fa-spinner fa-spin fa-fw"></i> Loading Backoffice...
</div>
<div *ngIf="loggingIn" class="appLoadingContainer">
  <i class="fa fa-spinner fa-spin fa-fw"></i> Logging into Backoffice...
</div>
<section *ngIf="pageLoaded && !loggingIn" id="loginForm">
  <mat-card>

    <mat-card-content>
      <h3>
        <div style="text-align:center; margin-bottom:20px; padding-top: 20px;">
          <img alt="TimeTap Logo"
               src="https://9a812d2609e610ab07eb-b463fa4ca2c8095be4f297e4d7f6781b.ssl.cf2.rackcdn.com/timetap-logo-dark.svg"
               style="max-width: 300px"/>
        </div>
      </h3>
      <!--Reactive drive approach-->
      <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
        <div class="row">
          <div class="col-4 offset-4" *ngIf="loginFailed">
            <alert type="danger">
              Your username and/or password are incorrect. Please try again.
            </alert>
          </div>
          <div class="col-12">
            <mat-form-field>
              <input
                formControlName="userName"
                matInput
                placeholder="Username"
                type="text">
              <mat-error>Username is missing or invalid</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <mat-form-field>
              <input
                formControlName="password"
                matInput
                placeholder="Password"
                type="password">
              <mat-error>Password invalid</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button [disabled]="loginForm.invalid || !pageLoaded" color="primary" mat-raised-button type="submit">Login</button>
          </div>
        </div>


      </form>
    </mat-card-content>
  </mat-card>
</section>


<script>(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({
    'gtm.start':
      new Date().getTime(), event: 'gtm.js'
  });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src =
    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-W7PV4Q9');
</script>
<!-- End Google Tag Manager -->
<script async src="https://www.googletagmanager.com/gtag/js?id=UA-45136139-1"></script>
<script>
  window.dataLayer = window.dataLayer || [];

  function gtag() {
    dataLayer.push(arguments);
  }

  gtag('js', new Date());

  gtag('config', 'UA-45136139-1');
</script>
